// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const SkuMasterPage = lazy(() => import('./pages/SkuMasterPage'));
const StockLevelsPage = lazy(() => import('./pages/StockLevelsPage'));
const LowStockAlertsPage = lazy(() => import('./pages/LowStockAlertsPage'));
const ReorderPointsPage = lazy(() => import('./pages/ReorderPointsPage'));
const InventoryReportsPage = lazy(() => import('./pages/InventoryReportsPage'));

export const InventoryRoutes: RouteObject = {
  path: 'inventory',
  element: <ModuleGuard moduleId="operations.inventory" />,
  children: [
    { path: 'sku-master', element: <SkuMasterPage />, handle: { crumb: 'Sku Master' } },
    { path: 'stock-levels', element: <StockLevelsPage />, handle: { crumb: 'Stock Levels' } },
    { path: 'low-stock-alerts', element: <LowStockAlertsPage />, handle: { crumb: 'Low Stock Alerts' } },
    { path: 'reorder-points', element: <ReorderPointsPage />, handle: { crumb: 'Reorder Points' } },
    { path: 'inventory-reports', element: <InventoryReportsPage />, handle: { crumb: 'Inventory Reports' } },
  ],
};
